import { types } from "./hubIntegrations.actions";
import { Reducer } from "../../services/reducer.factory";
import moment from "moment";

const initialState = {

  initialDateFilter: moment().startOf('month').toDate(),
  finalDateFilter: moment().toDate(),

  columns: [
    {
      field: "message",
      header: "Mensagem",
      columnKey: "message",
      sortable: false,
      filter: false
    },
    {
      field: "date",
      header: "Data",
      columnKey: "date",
      sortable: false,
      filter: false
    },
  ],

  modules: {
    sefaz: false,
    edi: false,
    manual: false,
    api: false,
  },

  credentials: {
    accountId: "",
    accountKey: "",
  },

  messageError: "",

  integrations: {
    focco: {
      enabled: true,
      title: "Focco",
      configuration: null
    },
    totvs: {
      enabled: true,
      title: "TOTVS",
      configuration: null
    },
    sankhya: {
      enabled: true,
      title: "Sankhya",
      configuration: null
    },
    fullsoft: {
      enabled: true,
      title: "Fullsoft",
      configuration: null
    },
    sap: {
      enabled: true,
      title: "SAP",
      configuration: null
    },
    promob: {
      enabled: true,
      title: "Promob",
      configuration: null
    },
    agileProcess: {
      enabled: true,
      title: "Agile",
      configuration: null
    },
    pressier: {
      enabled: true,
      title: "Pressier",
      configuration: null
    },
    eficacia: {
      enabled: true,
      title: "Eficacia",
      configuration: null
    },
    google: {
      enabled: true,
      title: "Google",
      configuration: null
    },
  },

  dialogErpMenu: {
    visible: false,
    header: "Integrações ERP",
    modal: true,
  },

  dialogNfeError: {
    visible: false,
    header: "Log NF-e",
    modal: true,
  },
  dialogCteError: {
    visible: false,
    header: "Log CT-e",
    modal: true,
  },

  dialogManualImport:{
    visible: false,
    header: "Importação Manual",
    modal: false,
  },

  dialogIntegrationConfiguration: {
    visible: false,
    header: "Configurações",
    modal: true,
  },
  autConfigurationOptions: [
    { label: 'Simples', value: 'SIMPLE' },
    { label: 'Bearer Token', value: 'BEARER' },

  ],
  autConfigurationValue: ["SIMPLE"],
  passwordNfePFX: "",
  passwordCtePFX: "",
  logCte:[],
  logNfe:[],
};

const reducer = new Reducer(initialState, types);

export function CRUDHubIntegrationsReducer(state, action) {
  state = reducer.execute(state, action);
  return execute(state, action);
}

function execute(state, action) {
  let result = state;
  switch (action.type) {
    case types.SET_LOOKUP_CARRIER_VISIBLE:
      return setLookupCarrierVisible(state, action)
    case types.SET_INITIAL_DATE_FILTER:
      return setInitialDateFilter(state, action);
    case types.SET_FINAL_DATE_FILTER:
      return setFinalDateFilter(state, action);
    case types.SET_EXPANDED_ORDERS_ROWS:
      return setExpandedOrdersRows(state, action);
    case types.SET_DIALOG_APPROVE_COMPONENT_VISIBLE:
      return setDialogApproveComponentVisible(state, action);
    case types.SET_CURRENT_APPROVE_COMPONENT_DESCRIPTION:
      return setCurrentApproveComponentDescription(state, action);
    case types.SET_DIALOG_APPROVE_COMPONENT_TYPE:
      return setDialogApproveComponentType(state, action);
    case types.SHOW_DIALOG_ERP_CONFIGURATION:
      return showDialogErpConfiguration(state, action);
    case types.SHOW_DIALOG_MANUAL_IMPORT:
      return showDialogManualImport(state, action);
    case types.CHANGE_AUT_HANDLER:
      return setAutValue(state, action);
    case types.SET_ORDERS_TO_APPROVE:
      return setOrdersToApprove(state, action);
    case types.ENABLE_SEFAZ_MODULE:      
      return enableSefazModule(state, action);
    case types.SET_ACTIVE_INTEGRATION:
      return setActiveIntegration(state, action);
    case types.ENABLE_API_MODULE:
      return enableApiModule(state, action);
    case types.SET_SAP_ENABLED:
      return setSapEnabled(state, action);
    case types.SET_FOCCO_ENABLED:
      return setFoccoEnabled(state, action);
    case types.SET_AGILE_ENABLED:
      return setAgileEnabled(state, action);
    case types.SET_FULLSOFT_ENABLED:
      return setFullsoftEnabled(state, action);
    case types.SET_GOOGLE_ENABLED:
      return setGoogleEnabled(state, action);
    case types.SET_PRESSIER_ENABLED:
      return setPressierEnabled(state, action);
    case types.SET_PROMOB_ENABLED:
      return setPromobEnabled(state, action);
    case types.SET_SANKHYA_ENABLED:
      return setSankhyaEnabled(state, action);
    case types.SET_TOTVS_ENABLED:
      return setTotvsEnabled(state, action);
    case types.PASSWORD_CTE_PFX:
      return setPasswordCtePFX(state, action);
    case types.ENABLE_EDI_MODULE:
      return enableEdiModule(state, action);
    case types.ENABLE_MANUAL_MODULE:
      return enableManualModule(state, action);
    case types.SHOW_DIALOG_ERP_MENU:
      return showDialogErpMenu(state, action);
    case types.SHOW_DIALOG_NFE_ERROR:
      return showDialogNfeError(state, action);
    case types.SHOW_DIALOG_CTE_ERROR:
      return showDialogCteError(state, action);
    case types.PASSWORD_PFX:
      return setPasswordPFX(state, action);
    case types.LOAD_CONFIGURATION_CTE:
      return loadConfigurationCte(state, action);
    case types.LOAD_CONFIGURATION_NFE:
      return loadConfigurationNfe(state, action);
    case types.SET_CREDENTIALS:
      return setCredentials(state, action);
    case types.SET_MESSAGE_ERROR:
      return setMessageError(state, action);
    default:
      return result;
  }
}

function setCredentials(state, action) {
  let credentials = action.credentials;
  state = { ...state, credentials };
  return state;
}

function setMessageError(state, action) {
  let messageError = action.messageError;
  state = { ...state, messageError };
  return state;
}

function setLookupCarrierVisible(state, action) {
  let auditoriaTrackingFilter = state.auditoriaTrackingFilter;
  let lookupCarrier = auditoriaTrackingFilter.lookupCarrier;
  lookupCarrier = Object.assign({}, lookupCarrier, { visible: action.visible });
  auditoriaTrackingFilter = Object.assign({}, auditoriaTrackingFilter, { lookupCarrier });
  state = Object.assign({}, state, { auditoriaTrackingFilter })
  return state;
}

function setInitialDateFilter(state, action) {
  let initialDateFilter = action.initialDateFilter;
  state = { ...state, initialDateFilter };
  return state;
}

function setFinalDateFilter(state, action) {
  let finalDateFilter = action.finalDateFilter;
  state = { ...state, finalDateFilter };
  return state;
}

function setExpandedOrdersRows(state, action) {
  let expandedOrders = action.expandedOrders;
  state = { ...state, expandedOrders };
  return state;
}

function setOrdersToApprove(state, action) {
  let approveOrder = action.approveOrder;
  let idEmbarque = 0;
  let cnpjCarrier = 0;
  let valueFreight = 0;
  let numberNFE = ""
  const records = state.records;
  for (let i = 0; i < records.length; i++) {
    for (let j = 0; j < records[i].orders.length; j++) {
      if (records[i].orders[j].code === approveOrder.code) {
        idEmbarque = records[i].oid;
        cnpjCarrier = records[i].carrier.cnpj
        valueFreight = records[i].orders.valueFreight
        numberNFE = records[i].orders.numberNFE
        break;
      }
    }
    if (idEmbarque > 0) {
      break;
    }
  }
  state = { ...state, approveOrder, idEmbarque, cnpjCarrier, valueFreight, numberNFE };
  return state;
}


// Dialog Approve Component
function setDialogApproveComponentVisible(state, action) {
  let dialogApproveComponent = { ...state.dialogApproveComponent, visible: action.visible };
  state = { ...state, dialogApproveComponent };
  return state;
}
function setDialogApproveComponentType(state, action) {
  let dialogApproveComponent = { ...state.dialogApproveComponent, approvalType: action.approvalType };
  state = { ...state, dialogApproveComponent };
  return state;
}
function setCurrentApproveComponentDescription(state, action) {
  let currentApproveComponent = { ...state.currentApproveComponent, description: action.description };
  state = { ...state, currentApproveComponent };
  return state;
}

function enableSefazModule(state, action) {
  let modules = state.modules;

  modules.sefaz = action.enable;
  modules.api = false
  modules.manual = false
  modules.edi = false
  state = { ...state, modules };
  return state;
}

function enableApiModule(state, action) {
  let modules = state.modules;

  modules.api = action.enable;
  modules.sefaz = false
  modules.manual = false
  modules.edi = false
  state = { ...state, modules };
  return state;
}

function enableEdiModule(state, action) {
  let modules = state.modules;

  modules.api = false;
  modules.sefaz = false
  modules.manual = false
  modules.edi = action.enable;
  state = { ...state, modules };
  return state;
}

function enableManualModule(state, action) {
  let modules = state.modules;

  modules.manual = action.enable;
  modules.sefaz = false
  modules.api = false
  modules.edi = false
  state = { ...state, modules };
  return state;
}

function showDialogErpMenu(state, action) {
  let dialogErpMenu = state.dialogErpMenu;

  dialogErpMenu.visible = action.enable;
  state = { ...state, dialogErpMenu };
  return state;
}

function showDialogNfeError(state, action) {
  let dialogNfeError = state.dialogNfeError;

  dialogNfeError.visible = action.enable;
  state = { ...state, dialogNfeError };
  return state;
}
function showDialogCteError(state, action) {
  let dialogCteError = state.dialogCteError;

  dialogCteError.visible = action.enable;
  state = { ...state, dialogCteError };
  return state;
}

function showDialogErpConfiguration(state, action) {
  let dialogIntegrationConfiguration = {...state.dialogIntegrationConfiguration};
  let integrations = {...state.integrations};

  dialogIntegrationConfiguration.visible = action.enable;
  const integrationTitle = integrations[action.name]?.title;
  if (integrationTitle) {
    dialogIntegrationConfiguration.header = "Configurações "+integrationTitle;
  }
  // dialogIntegrationConfiguration.header = (dialogIntegrationConfiguration.header ) + " " + (integrations[action.title]?.title);
  state = { ...state, dialogIntegrationConfiguration };
  return state;
}

function showDialogManualImport(state, action) {
  let dialogManualImport = state.dialogManualImport;

  dialogManualImport.visible = action.enable;
  state = { ...state, dialogManualImport };
  return state;
}

function setPasswordPFX(state, action) {
  let passwordNfePFX = state.passwordNfePFX

  passwordNfePFX = action.password
  state = { ...state, passwordNfePFX };
  return state;
}

function setPasswordCtePFX(state, action) {
  let passwordCtePFX = state.passwordCtePFX

  passwordCtePFX = action.password
  state = { ...state, passwordCtePFX };
  return state;
}

function setAutValue(state, action) {
  let autConfigurationValue = state.autConfigurationValue;
  autConfigurationValue = action.value;
  state = { ...state, autConfigurationValue };
  return state;
}

function setActiveIntegration(state, action) {
  let integrations = Object.keys(state.integrations).reduce((acc, key) => {
    acc[key] = {
    enabled: key === action.integrationName,
    title: key === action.integrationName ? action.integrationTitle : state.integrations[key].title
    };
    return acc;
  }, {});

  return { ...state, integrations };
}


function setSapEnabled(state, action) {
  let integrations = state.integrations;
  integrations.sap.enabled = action.value;
  integrations.focco.enabled = false;
  integrations.totvs.enabled = false;
  integrations.sankhya.enabled = false;
  integrations.fullsoft.enabled = false;
  integrations.promob.enabled = false;
  integrations.agileProcess.enabled = false;
  integrations.pressier.enabled = false;
  integrations.eficacia.enabled = false;
  integrations.google.enabled = false;
  state = { ...state, integrations };
  return state;
}

function setFoccoEnabled(state, action) {
  let integrations = state.integrations;
  integrations.focco.enabled = action.value;
  integrations.totvs.enabled = false;
  integrations.sankhya.enabled = false;
  integrations.fullsoft.enabled = false;
  integrations.promob.enabled = false;
  integrations.agileProcess.enabled = false;
  integrations.pressier.enabled = false;
  integrations.eficacia.enabled = false;
  integrations.google.enabled = false;
  state = { ...state, integrations };
  return state;
}

function setAgileEnabled(state, action) {
  let integrations = state.integrations;
  integrations.agileProcess.enabled = false;
  integrations.focco.enabled = false;
  integrations.totvs.enabled = false;
  integrations.sankhya.enabled = false;
  integrations.fullsoft.enabled = false;
  integrations.promob.enabled = false;
  integrations.pressier.enabled = false;
  integrations.eficacia.enabled = false;
  integrations.google.enabled = false;
  state = { ...state, integrations };
  return state;
}

function setFullsoftEnabled(state, action) {
  let integrations = state.integrations;
  integrations.fullsoft.enabled = action.value;
  integrations.focco.enabled = false;
  integrations.totvs.enabled = false;
  integrations.sankhya.enabled = false;
  integrations.promob.enabled = false;
  integrations.agileProcess.enabled = false;
  integrations.pressier.enabled = false;
  integrations.eficacia.enabled = false;
  integrations.google.enabled = false;
  state = { ...state, integrations };
  return state;
}

function setGoogleEnabled(state, action) {
  let integrations = state.integrations;
  integrations.google.enabled = action.value;
  integrations.focco.enabled = false;
  integrations.totvs.enabled = false;
  integrations.sankhya.enabled = false;
  integrations.fullsoft.enabled = false;
  integrations.promob.enabled = false;
  integrations.agileProcess.enabled = false;
  integrations.pressier.enabled = false;
  integrations.eficacia.enabled = false;
  state = { ...state, integrations };
  return state;
}

function setPressierEnabled(state, action) {
  let integrations = state.integrations;
  integrations.pressier.enabled = action.value;
  integrations.focco.enabled = false;
  integrations.totvs.enabled = false;
  integrations.sankhya.enabled = false;
  integrations.fullsoft.enabled = false;
  integrations.promob.enabled = false;
  integrations.agileProcess.enabled = false;
  integrations.eficacia.enabled = false;
  integrations.google.enabled = false;
  state = { ...state, integrations };
  return state;
}

function setPromobEnabled(state, action) {
  let integrations = state.integrations;
  integrations.promob.enabled = action.value;
  integrations.focco.enabled = false;
  integrations.totvs.enabled = false;
  integrations.sankhya.enabled = false;
  integrations.fullsoft.enabled = false;
  integrations.agileProcess.enabled = false;
  integrations.pressier.enabled = false;
  integrations.eficacia.enabled = false;
  integrations.google.enabled = false;
  state = { ...state, integrations };
  return state;
}

function setSankhyaEnabled(state, action) {
  let integrations = state.integrations;
  integrations.sankhya.enabled = action.value;
  integrations.focco.enabled = false;
  integrations.totvs.enabled = false;
  integrations.fullsoft.enabled = false;
  integrations.promob.enabled = false;
  integrations.agileProcess.enabled = false;
  integrations.pressier.enabled = false;
  integrations.eficacia.enabled = false;
  integrations.google.enabled = false;
  state = { ...state, integrations };
  return state;
}

function setTotvsEnabled(state, action) {
  let integrations = state.integrations;
  integrations.totvs.enabled = action.value;
  integrations.focco.enabled = false;
  integrations.sankhya.enabled = false;
  integrations.fullsoft.enabled = false;
  integrations.promob.enabled = false;
  integrations.agileProcess.enabled = false;
  integrations.pressier.enabled = false;
  integrations.eficacia.enabled = false;
  integrations.google.enabled = false;
  state = { ...state, integrations };
  return state;
}

function loadConfigurationCte(state, action) {
  let logCte = action.logCte;
  state = { ...state, logCte };
  return state;
}

function loadConfigurationNfe(state, action) {
  let logNfe = action.logNfe;
  state = { ...state, logNfe };
  return state;
}


// function loadConfigurationCte(state, action) {
//   let logCte = action.logCte;
//   let records = state.records

//   if (logCte?.records?.length >=0) { 
//    for (let i = 0; i < logCte?.records?.length; i++) {
//     if (logCte?.records[i]?.oid != records[i]?.oid) {
//       records.push(logCte?.records[i])
//     }
//    }
//   }
  
//   return{
//     ...state,
//     logCte,
//     records: [...state.records]
//   }
// }

// function loadConfigurationNfe(state, action) {
//   let logNfe = action.logNfe;
//   let records = state.records

//   if (logNfe?.records?.length >=0) { 
//    for (let i = 0; i < logNfe?.records?.length; i++) {
//     if (logNfe?.records[i]?.oid != records[i]?.oid) {
//       records.push(logNfe?.records[i])
//     }
//    }
//   }
  
//   return{
//     ...state,
//     logNfe,
//     records: [...state.records]
//   }
// }